import { Component, inject } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { TableCellType } from 'src/modules/sm-base/models/table-cell-type.enum';
import { TableColumn } from 'src/modules/sm-base/models/table-column.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableSortColumn } from 'src/modules/sm-base/models/table-sort-column.model';
import { EnaioCertificateService } from '../../services/enaio-certificate.service';
import { ClassRegister } from '../../shared/class-register.entity';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';

@Component({
  selector: 'app-class-history',
  templateUrl: './class-history.component.html',
  styleUrls: ['./class-history.component.scss']
})
export class ClassHistoryComponent extends ComponentView {

    service = inject(EnaioCertificateService);

    neededParams: ObjectOfSimpleDataTypes = { id: "number" };
    id: number;

    classRegister: ClassRegister;
    table: TableData;

    async initParams(): Promise<boolean> {
        this.classRegister = await this.service.restGetClassRegister(this.id, ["history"], null, true);

        this.table = new TableData([
            new TableColumn("changeDate", "Datum/Uhrzeit", TableCellType.dateTime, { autoWidth: 1 }),
            new TableColumn("changedBy", "Benutzer"),
            new TableColumn("modification", "Änderung")
        ], this.classRegister.history.map(hi => new TableRow("", hi, {
            changeDate: hi.changeDate,
            changedBy: hi.changedBy,
            modification: hi.modification
        })), [new TableSortColumn("changeDate", false)]);

        await this.service.updateNavigationClassRegister(this.id, [
            { label: "Historie", routerLink: ["/enaio-certificates", "class-registers", "history", this.id] }
        ]);
        return true;
    }
}
